module.exports = "/365FarmNet/dist/cfn-stock-fill-display.tpl.1ab9466339a897341dc5543b421fc265.html";